<ul class="nav nav-tabs justify-content-start">
    <li *ngIf="hasRole(TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES)" class="nav-item">
      <a class="nav-link" routerLink="consolidado" routerLinkActive="active">Reporte Consolidado</a>
    </li>
    <li *ngIf="hasRole(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.TUTOR, TipoUsuario.CONSAEROVALES)" class="nav-item">
      <a class="nav-link" routerLink="resolucionMensual" routerLinkActive="active">Resolución Mensual </a>
    </li>
    <li *ngIf="hasRole(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE)" class="nav-item">
      <a class="nav-link" routerLink="anulacionAerovales" routerLinkActive="active">Reporte Anulación Aerovales </a>
    </li>
    <li *ngIf="hasRole(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SUPERVISOR, TipoUsuario.TUTOR, TipoUsuario.SOPORTE)" class="nav-item">
      <a class="nav-link" routerLink="reporteMovimientos" routerLinkActive="active">Reporte Movimientos</a>
    </li>
</ul>

<router-outlet></router-outlet>
